import { urlForSpace } from "@src/utils/endpoints-urls";

export function urlForLiveShuttleSummary(spaceId: string): string {
  return `${urlForSpace(spaceId)}/live-shuttle/summary`;
}

export function urlForRecentLiveShuttles(spaceId: string): string {
  return `${urlForSpace(spaceId)}/live-shuttle/recent`;
}